










/* ----------------------------------------
    Imports
---------------------------------------- */

import { Component } from 'vue-property-decorator';
import { Message as BaseMessage } from '@fruitpackage/components';

/* ----------------------------------------
    Component
---------------------------------------- */

@Component({
    data() {
        return {
            _componentContent: null,
            _componentContentData: null,
            _duration: null,
        }
    },

    created() {
        this._componentContent = this.componentContent;
        this._componentContentData = this.componentContentData;
        this._duration = this.duration;
    }
})

/* ----------------------------------------
    Export
---------------------------------------- */

export default class Message extends BaseMessage {}

